export default "__VITE_ASSET__TC89bAI9__"